<template>
    <!--弹窗-->
    <el-dialog
        width="640px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form ref="formData" :inline="false" class="query-form" size="mini" :rules="rules" :model="formData" :label-position="'left'">

            <el-form-item label="类型：" class="query-form-item" prop="type">
                <el-select v-model="formData.type" placeholder="请选择类型" size="mini">
                    <el-option label="义乌" value="义乌"></el-option>
                    <el-option label="盈和" value="盈和"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="FBA入仓号：" class="query-form-item" prop="warehouse_number">
                <el-input v-model="formData.warehouse_number" placeholder="请输入FBA入仓号" style="width: 200px;"></el-input>
            </el-form-item>

            <el-form-item label="Reference ID：" class="query-form-item" prop="reference_id" >
                <el-input v-model="formData.reference_id" placeholder="请输入Reference ID" style="width: 200px;"></el-input>
            </el-form-item>

            <el-form-item label="仓库代码：" class="query-form-item" prop="logistics_address_id">
                <el-select v-model="formData.logistics_address_id" placeholder="请选择" size="mini" filterable style="width: 200px;">
                    <el-option :label="item.warehouse_code" :value="item.id"
                               v-for="item in addressList"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="编号：" class="query-form-item">
                <el-input v-model="formData.number" placeholder="请输入编号" style="width: 200px;"></el-input>
            </el-form-item>

        </el-form>

        <div class="wrapBox">
            <el-form label-width="180px" size="mini">
                <div class="top">
                    <div style="font-weight: 900;">下载模板</div>
                    <div>
                        <a href="/export/发票上传模板.xlsx"
                           style="text-decoration: underline; color: rgb(58, 142, 230);">点击下载“发票上传”模板</a>
                    </div>
                </div>
                <div class="download">
                    <el-upload
                        class="upload-demo"
                        drag
                        action="/"
                        accept=".xls, .xlsx"
                        ref="upload"
                        :file-list="files"
                        :http-request="handleUpload"
                        :on-exceed='handExceed'
                        :on-remove="handleRemove"
                        :auto-upload="false"
                        :limit="1"
                        multiple>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__text" style="font-size: 12px;margin-top: 5px;">只能上传.xls/.xlsx文件
                        </div>
                    </el-upload>
                </div>
            </el-form>
            <el-row class="bottomBox">
                <el-button
                    style="float:right;margin-left:6px;"
                    size="mini"
                    type="danger"
                    plain
                    @click="handleClose()"
                >取 消
                </el-button>
                <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')">确定
                </el-button>
            </el-row>
        </div>
    </el-dialog>
</template>
<script>
    import * as api from '@/api/advAnalys/advAnalys.js'

    export default {
        data() {
            return {
                addressList: [],
                formData: {
                    type: undefined,
                    number: undefined,
                    logistics_address_id: undefined,
                    warehouse_number: undefined,
                    reference_id: undefined,
                    box_datas: [],
                },
                managerAnalysisList: [],
                categoryList: [],
                files: [],
                disabled: false,
                textarea: '',
                date: [],
                dateArr: [
                    {title: '最新日期区间', val: 2},
                    {title: '最新日期', val: 1}
                ],
                dateType: 1,
                query: {
                    state: '',
                },
                rules: {
                    type: [
                        {
                            required: true,
                            message: '请选择类型',
                            trigger: 'blur'
                        },
                    ],
                    logistics_address_id: [
                        {
                            required: true,
                            message: '请选择物流地址',
                            trigger: 'blur'
                        },
                    ],
                    warehouse_number: [
                        {
                            required: true,
                            message: '请输入FBA入仓号',
                            trigger: 'blur'
                        },
                    ],
                    reference_id: [
                        {
                            required: true,
                            message: '请输入Reference ID',
                            trigger: 'blur'
                        },
                    ],
                },
            }
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
        },
        watch: {
            visible: {
                handler(val) {
                    val && this.getManagerAnalysisList()
                },
                immediate: true,
                deep: true
            },
        },
        methods: {
            getManagerAnalysisList() {
                api.logistics_address_lists().then((res) => {
                    if (res.code == 0) {
                        this.addressList = res.data || []
                    }
                })
            },
            handleUpload(raw) {
                this.files.push(raw.file)
            },
            handExceed(files, fileList) {
                this.$message({
                    type: 'warning',
                    message: `当前限制选择 1 个文件，共选择了 ${files.length +
                    fileList.length} 个文件.`
                })
                return
            },
            handFileSuccess() {
                this.files = []
                this.$refs.upload.clearFiles()
            },
            handleRemove(file, fileList) {
                this.files = fileList
            },
            // 保存信息
            // 保存信息
            submitForm(formData) {
                this.$refs[formData].validate(valid => {
                    if (valid) {
                        this.$refs.upload.submit() // 这里是执行文件上传的函数，其实也就是获取我们要上传的文件
                        if (this.files.length == 0) {
                            this.$message.warning(`当前限制只能上传选择 1 个文件`)
                            return
                        }
                        let file = new FormData()
                        file.append('file', this.files[0])
                        file.append('type', this.formData.type)
                        file.append('number', this.formData.number)
                        file.append('logistics_address_id', this.formData.logistics_address_id)
                        file.append('warehouse_number', this.formData.warehouse_number)
                        file.append('reference_id', this.formData.reference_id)
                        this.loading = true
                        api.logistics_invoice_create(file).then(res => {
                            if (res.code === 0) {
                                this.loading = false
                                this.$message({
                                    type: 'success',
                                    message: '添加成功'
                                })
                                this.handleClose(true)
                            } else {
                                this.loading = false
                                this.$message({
                                    type: 'error',
                                    message: res.message
                                })
                            }
                        })
                            .catch(() => {
                                this.loading = false
                                this.$message({
                                    type: 'error',
                                    message:
                                        '网络出现问题，请查看数据是否添加完成！'
                                })
                            })
                    } else {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '请填写相应内容！'
                        })
                    }
                })
            },
            // 关闭弹窗
            handleClose(isshow) {
                this.files = []
                this.formData = {
                    number: undefined,
                    logistics_address_id: undefined,
                    warehouse_number: undefined,
                    reference_id: undefined,
                    box_datas: [],
                }
                this.$emit('close-callback', isshow)
                this.disabled = false
            }
        }
    }
</script>
<style type="text/scss" lang="scss">
    .wrapBox {
        width: 600px;
        margin-top: 10px;

        .bottomBox {
            margin-top: 17px;
            display: flex;
            justify-content: center;
        }
    }

    .download {
        display: flex;
        justify-content: center;
    }

    .top {
        margin: 0px auto 20px;
        width: 60%;
        display: flex;
        justify-content: space-between;
    }
</style>
